import {
  AppleLogo,
  GoogleHealthConnectLogo,
  StravaLogo,
  WildLogo,
} from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

const activityAndMovementIntegrationsData: LandingPageIntegrationData[] = [
  {
    description: 'activity_integration_apple',
    Logo: AppleLogo as SVGIconComponent,
    name: 'apple',
  },
  {
    description: 'activity_integration_strava',
    Logo: StravaLogo as SVGIconComponent,
    name: 'strava',
  },
  {
    description: 'activity_integration_health_connect',
    Logo: GoogleHealthConnectLogo as SVGIconComponent,
    name: 'healthconnect',
    logoClassName: 'max-w-20 overflow-hidden',
  },
  {
    description: 'activity_integration_wild',
    Logo: WildLogo as SVGIconComponent,
    name: 'wild',
  },
].map(
  (integration) =>
    ({
      ...integration,
      logoClassName: cx('h-16', integration.logoClassName),
    }) as LandingPageIntegrationData,
);

export default activityAndMovementIntegrationsData;
